import { IEnvironment } from './environment.interface';
import { EnvironmentsEnum } from './environments.enum';

export const environment: IEnvironment = {
  env: EnvironmentsEnum.production,
  production: true,
  gatewayUrl: 'https://gateway.2go.com',
  baseDomain: '2go.com',
  domain: '2go.com',
  segmentWriteKey: 'ZekyFJTQdfrdEO4POLlFG1DOH69fv59f',
  accountServerUrl: 'https://account.2go.com',
  debugMode: false,
  raygunAPIKey: 'n+Zt6W29thJZJC0YFwQcVg==',
  version: '10.160.4', // git tag version set by Jenkins
  commit: '', // never set
  features: {
    featureFramework: true,
  },
  auth0Url: 'https://invoice2go-prod.us.auth0.com',
  auth0ClientId: 'ALJ9b5KN9HVDxgeqdvucYyUcon4L21uy',
  auth0ClientSecret:
    'IFJFOpnHqWtZPz1VZK8uayKtBxHeqs_XNkXxH15MTGqDTcWuU0kqEbhxyLFgFvMY',
  paymentsPortalUrl: 'https://pay.2go.com',
  redirectServiceUrl: 'https://redirect.2go.com',
  billingUrl: 'https://billing.2go.com',
  documentEmailTemplateId: 'id7_document_email_spamcheck',
  statementEmailTemplateId: 'id_statement_email_spamcheck',
  invoiceEmailTemplateId: 'invoice_email',
};
